import React from 'react';

import './account-detail.scss';
import { capitalize, currencyFormat } from 'utilities/core-utilities';
import ModalCoreContent from 'components/modal-core-content/modal-core-content';
import { useSelector } from 'react-redux';

/**
 * Account detail balance summary
 * @param account Account item to view
 */
const AccountDetail = ({ account, balance }) => {
  const contractBalances = useSelector((state) => state.accountsStore.contractBalances);
  const contractBalancesLoading = useSelector((state) => state.accountsStore.contractBalancesLoading);

  const accountBalances = contractBalances?.map(x => {
    return {
      key: capitalize(x.balanceCode),
      value: currencyFormat(x.balanceValue),
    };
  });

  const details = [
    ...[
      {
        'key': 'Status',
        'value': account.status,
      },
      {
        'key': 'Today\'s Balance',
        'value': currencyFormat(balance),
      },
      {
        'key': 'Available Credit',
        'value': currencyFormat(account.available),
      },
      {
        'key': 'Credit Limit',
        'value': currencyFormat(account.creditLimit),
      },

    ],
    ...accountBalances,
  ];

  return <>
    <ModalCoreContent
      data={details}
      isLoading={contractBalancesLoading}
    />
  </>;
};

export default AccountDetail;
